import { C, F, Card, SectionHead } from '../../../tokens';

// Placeholder shell — no data, no charts. Sprint 1a is frontend-only.
export default function PulseTab() {
  return (
    <div style={{display:"flex",flexDirection:"column",gap:16}}>
      <SectionHead title="Pulse" sub="A live read on the health of this business — surfaced from Compass's understanding of its goals, data, and momentum." />
      <Card style={{padding:"40px 28px",textAlign:"center"}}>
        <div style={{fontFamily:F.display,fontSize:18,color:C.charcoal,fontWeight:600,marginBottom:8}}>Coming soon</div>
        <div style={{fontFamily:F.body,fontSize:13,color:C.charMid,maxWidth:440,margin:"0 auto",lineHeight:1.5}}>
          Once Compass is connected to this client's goals, KPIs, and data sources, the Pulse view will summarize what's moving, what's stalled, and what deserves attention — at a glance.
        </div>
      </Card>
    </div>
  );
}
